import { useEffect } from 'react';
import { ContentCard } from '../components';
// @ts-ignore
import ProfileImage from '../utils/images/bg_black.png';
// @ts-ignore
import ProfileImage2 from '../utils/images/bg_white.png';
//@ts-ignore
import DownloadIcon from '../utils/icons/download.svg';
import { ConfettiEffect, PixelAnimationWrapper } from '../utils/animations';
import { LocationSection } from '../components/location';
import { annotate } from 'rough-notation';
import { colors } from '../utils/colors';

const ApplyAnnotationDesign = (elementParam, style) => {
  document.querySelectorAll(elementParam).forEach((element) => {
    annotate(element, {
      type: style?.type || 'underline',
      color: style?.color || 'red',
      iterations: style?.iterations || 2,
      strokeWidth: 1.5,
      padding: style?.padding || [2, 3],
      ...style
    }).show();
  });
};

export const HeroSection = () => {
  useEffect(() => {
    ApplyAnnotationDesign('span.boxAnnotation', { type: 'box', color: 'red' });
    ApplyAnnotationDesign('span.underlineAnnotation', {
      type: 'underline',
      color: 'orange',
      multiline: true
    });
    ApplyAnnotationDesign('span.hightLightAnnotation', {
      type: 'highlight',
      color: 'yellow',
      multiline: true
    });
    ApplyAnnotationDesign('span.bracketAnnotation', {
      type: 'underline',
      color: 'red',
      multiline: true
    });
  }, []);

  return (
    <ContentCard className='gap-4'>
      <div className='flex gap-4 items-center z-10 relative top-[0]'>
        <div className='w-[95px] h-[95px] md:w-[125px] md:h-[125px] object-contain bg-skyBlue border-2 border-black rounded-radi-md'>
          <PixelAnimationWrapper
            firstContent={<img src={ProfileImage} alt='Logo GIF' className='w-full h-full scale-[1.2]' />}
            secondContent={
              <div className='w-fill h-full grid items-center justify-center bg-darkBlack'>
                <img src={ProfileImage2} alt='Logo2 GIF' className='w-full h-full scale-[1.2]' />
              </div>
            }
            gridSize={12}
            pixelColor={colors.pureWhite}
            animationStepDuration={0.6}
            className='custom-pixel-card'
          />
        </div>
        <div className='flex flex-col gap-2'>
          <div className='relative'>
            <h1 className='text-[2rem] md:text-[2.75rem] font-fraunces'>
              Meet Patel
              {/* <ConfettiEffect
                title={`, ${moment().diff(
                  moment('1999-11-30').valueOf(),
                  'years'
                )}`}
              />
              <span>
                <sup>*</sup>
              </span> */}
            </h1>
            <LocationSection locationTitle={'Vadodara, India'} />
          </div>
        </div>
      </div>

      <div className='relative flex flex-col gap-4'>
        <p className='text-secondaryMineShaft'>
          I am a{' '}
          {/* <ConfettiEffect
            title={moment().diff(moment('1999-11-30').valueOf(), 'years')}
          />
          -year-old{' '} */}
          <span className='boxAnnotation ml-0.5 mr-1'>software enthusiast</span> from Bharuch, India, who is imaginative
          and deadline-oriented. I enjoy <span className='hightLightAnnotation'>designing unique</span> and{' '}
          <span className='hightLightAnnotation'>trendy</span> concepts that come to mind and try to incorporate other
          talents to develop both technical and non-technical skills.
        </p>
        <p className='text-secondaryMineShaft'>
          I am passionate about <span className='underlineAnnotation'>UI/UX</span>,{' '}
          <span className='underlineAnnotation'>web design and development</span>, and{' '}
          <span className='underlineAnnotation'>graphic design</span>. I am also fond of motor sports, motorcycles,
          watches and anything with technology in it.
        </p>
        <p className='text-secondaryMineShaft'>
          I am an{' '}
          <span className='bracketAnnotation'>inquisitive, focused, self-assured and determined individual</span>. I am
          a quick learner with a willingness to learn at all times. I'm also capable of working under duress. Strangers
          inspire me with new ideas, therefore I enjoy talking to them. These are my perks.
        </p>
        <ConfettiEffect
          title={
            <a href='/docs/Meet%20Patel%20-%20CV.pdf' download>
              <span className='small flex gap-1 items-center'>
                Download Resume
                <img src={DownloadIcon} width='20px' height='20px' alt='' />
              </span>
            </a>
          }
        />
      </div>
    </ContentCard>
  );
};
